import React, {useEffect, useState} from 'react';
import './style.css'
import QRCode from "react-qr-code";
import { getData } from '../../../helpers/indexedDbHelper';
import { useRefresh } from '../../../hooks/useRefresh';
import ListProducts from '../../../screens/menu/ListProducts';
import HappyHourScreen from '../../../screens/menu/happyHour';
import { store } from '../../../redux/store';
import { setGoHome } from '../../../redux/slices/initLoad/types';
import { useSelector } from 'react-redux';
import ChangeLang from '../../../components/changeLang'
import { useTranslation } from 'react-i18next';

const Index = ({ showBack = true, showHome = true, showImageTop = false, children, showLogo=true, showFooter=true, setShowListProduct, setShowSpecials, goHome, goCategories }) => {
   
   const { i18n } = useTranslation();
  const langEng = i18n.language === 'en' ?? false;

      const [showModal, setShowModal] = useState(false);
  
  const [showBoost, setshowBoost] = React.useState(false);
  const [showModalPincode, setShowModalPincode] = React.useState(false);
  const [secret, setScret] = React.useState("");

  const [menus, setMenus] = useState([]);
  const { change } = useRefresh();
  const [dataDrinks, setDataDrinks] = useState(false);
  const [dataEntress, setdataEntress] = useState(false);
  const [dishs, setdishs] = useState(false);
       const [showListProduct2, setShowListProduct2] = useState(false);
      const [showHappy, setShowHappy] = useState(false);
  
  
   const {
      goHomeInit
   } = useSelector((state) => state.initLoad);
  
  const handleButtonClick = () => {
    if (setShowListProduct) {
      setShowListProduct(false); 
    }
  };

    const validScret = () => {

    if (secret === '') {
      alert('Debe ingresar el pin')
    }

    if (secret === "2355") {
       window.location.reload();
    } else {
       alert('Code invalid')
    }
    
  }

  
   useEffect(() => {
          getData('menu').then((items) => {
              const data = items.value.data;
             
              setMenus(data);
          });
      }, [change]);
      
     useEffect(() => {
              menus.map((item) => {
                  if (item.id === 491) {
                    setDataDrinks(item);
                  }
                  if (item.id === 482) {
                    setdataEntress(item);
                  }
                 
              });
     }, [menus]);
  
  
  
       useEffect(() => {
              console.log(goHomeInit, 'q mas qlq')
                setShowListProduct2(false);
              setShowHappy(false)
              
       }, [goHomeInit]);
      

  
    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

  
    return (
      <div className='backgroundlayout' style={{
        flex: 1,
        backgroundSize: 'cover',
        width: '100%',
        height: '100vh',
       
      }}>

        <img src={require('./assets/top.png')} style={{
          position: 'absolute',
          objectFit: 'contain',
          left: 0,
            top: -10,
            width: 400,
          height: 200,
            zIndex: 1
        }} />
        
        <img src={require('./assets/bottom.png')} style={{
          bottom: -60,
        
            right: 0,
            position: 'absolute',
            objectFit: 'contain',
            width: 200,
          height: 200,
              zIndex: 1
        }}/>
        
        <div>
          {/*<button onClick={()=>setOpenNav(!openNav)} style={{...styles.iconMenuMobile, ...iconMenu}}>
            <Menu />
          </button>*/}
          

          <div className='contentChild' >

            <div className='nav-menu-bar' style={{
             
              width: '100%',
              position: 'relative'
            
            }}>
               
              {showLogo &&
              <div style={{
               
                paddingTop: 20,
                paddingBottom: 20,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: showBack ? 'space-between':'flex-end',
            
                }}>
                  
                  <div style={{ display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',}}>
                     {showBack && (
                        <div
                            onClick={()=>handleButtonClick()}
                                style={{
                                   width: 170,
                                  height: 60,
                                  backgroundColor: '#E81562',
                                  borderRadius: 5,
                                  marginInline: 30,
                                  paddingInline: 15,
                                  zIndex: 999,
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  boxSizing: 'border-box',
                                  alignItems: "center"
                            }}>
                              <img
                                src={require('./assets/back.png')}
                                style={{width: 40, height: 40, resizeMode: 'contain'}}
                              />
                           
                        <p style={{ color: 'white', fontSize: 20, fontWeight: '900' }}>
                          
                          {langEng ? "GO BACK": "IR ATRAS"}
                          
                        </p>
                          </div>
                    )}

                  </div>
                  
                  <div style={{
                      alignItems: 'center',}}   >
                       <div style={{
                      
                        display: 'flex',
                          alignItems: 'center',
                              position: 'relative',
                              zIndex: 999,
                              justifyContent: 'end',}}>
                        <div onClick={()=>setShowModal('https://www.instagram.com/mrcactusnj/')} target='_blank'> <img
                        style={{
                          width: 28,
                            height: 28,
                            marginInline: 10
                        
                      }}
                      src={require('./assets/instagram.png')}
                      alt="Logo"
                      /> 
                      </div>

                      <div target='_blank' onClick={()=>setShowModal('https://www.facebook.com/tacosnj/')}> 
                        <img
                          style={{
                              width: 28,
                                height: 28,
                                marginInline: 10
                        }}
                          src={require('./assets/facebook.png')}
                          alt="Logo"
                        /> 
                      </div>

                      <ChangeLang />

                      {/* <div target='_blank' onClick={()=>setShowModal('https://stanciaperuvianfusion.com/?fbclid=PAZXh0bgNhZW0CMTEAAabcJIytXY618p9SWTbgSUCDqZjeqqwDe6N-mVtvD2e3OsRHHxJ4b-C03sg_aem_ySjBYnYb0DeoIbZGrDsMbQ')}> 
                        <img
                          style={{
                              width: 30,
                                height: 30,
                                marginInline: 10
                        }}
                          src={require('./assets/web.png')}
                          alt="Logo"
                        /> 
                      </div>
                             */}
                  
                    <div>
                    
                    </div>
                      </div>
                  </div>

                 
              </div>
              }
              


            

            </div>
            {children}





            {showModalPincode &&
              <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                
                <div style={{ position: 'absolute',background: '#fff', width: 500, height: 300, borderRadius: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column" }}>
                  <img
                      onClick={()=>setShowModalPincode(false)}
                    style={{
                      position: 'absolute',
                      top: -10,
                      
                                width: 40,
                                  height: 40,
                                  marginInline: 10,
                                  objectFit: 'contain',
                                  position: 'absolute',
                                  right: -10,
                                  zIndex: 9999
                              
                            }}
                      src={require('./assets/close.png')}
                      alt="Logo"
                  /> 
                  <h4 style={{ color: '#000', fontSize: 40, fontWeight: 'bold', margin: 20 }}>PIN</h4>
                  <input type='number' style={{ width: 300, height: 40 }} onChange={(e) => {
                    setScret(e.target.value)
                  }} />
                  <br /><br />
                  
                  <div style={{display: 'flex', gap: 20}}>
                    <div onClick={() => setShowModalPincode(false)} style={{background: '#000', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7}}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>atras</p>
                    </div>
                    <div onClick={()=>validScret()} style={{ background: '#000', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7 }}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>Enviar</p>
                  </div>
                </div>
                </div>
              </div>
            }

            <img
                onClick={()=>setShowModalPincode(true)}
                        style={{
                          width: 40,
                            height: 40,
                            marginInline: 10,
                            objectFit: 'contain',
                            position: 'absolute',
                            bottom: -1,
                            right: 0,
                            zIndex: 9999
                        
                      }}
                src={require('./assets/pincode.png')}
                alt="Logo"
            /> 


            
            {showFooter &&
            <div
            style={{
              position: 'absolute',
              bottom: -15,
                  alignSelf: 'center',
                  width: '100%',
                  left: 0,
                  zIndex: 999

            }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 20,
                    width: '100%',
                
                  }}>
                  
                  {showHome && 
                    <div
                 onClick={() => {
                      handleButtonClick()
                          store.dispatch(setGoHome(!goHomeInit));
                      console.log({goHome})
                      if (goHome) {
                        goHome()
                      }
                }}
                style={{
                  width: 160,
                  height: 70,
                  backgroundColor: '#E81562',
                  borderRadius: 9,
                  marginHorizontal: 10,
                  justifyContent: 'space-around',
                  paddingHorizontal: 20,
                  alignItems: 'center',
                  flexDirection: 'row',
display: 'flex',
                  shadowColor: '#000',
                  shadowOffset: {
                    width: 3,
                    height: 5,
                  },
                  shadowOpacity: 0.14,
                  shadowRadius: 0,
                  elevation: 10,
                }}>
                <img
                  src={require('./assets/home.png')}
                  style={{
                    width: 30,
                    height: 30,
                  }}
                />

                <p
                  style={{
                    color: '#F0D26A',
                    
                    fontFamily: 'Roadstore',
                    fontSize: 22,
                    textShadowColor: '#E01417',
                    textShadowOffset: {width: 2, height: 1},
                    textShadowRadius: 1,
                    textTransform: 'uppercase',
                        }}>
                        
                        {langEng ? "Home": "INICIO"}
                 
                </p>
                  </div>
                  }
                  
                  
             
                  <div
                    onClick={() => {
                      if (goCategories) {
                        goCategories(true)
                      }
              }}
              style={{
                width: 210,
                height: 70,
                backgroundColor: '#F7FF05',
                borderRadius: 9,
                marginHorizontal: 10,
                display: "flex",
                justifyContent: 'space-around',
                paddingHorizontal: 20,
                alignItems: 'center',
                flexDirection: 'row',

                shadowColor: '#000',
                shadowOffset: {
                  width: 3,
                  height: 5,
                },
                shadowOpacity: 0.14,
                shadowRadius: 0,
                elevation: 10,
              }}>
              <img
                src={require('./assets/categorie.png')}
                style={{
                  width: 30,
                  height: 30,
                  marginRight: 10,
                }}
              />

              <p
                style={{
                  color: '#E81562',
                
                  fontSize: 22,
                  textTransform: 'uppercase',
                  fontFamily: 'Roadstore',
                  textShadowColor: '#F0D26A',
                  textShadowOffset: {width: 2, height: 1},
                  textShadowRadius: 1,
                      }}>
                      
                      {langEng ? "Categories": "Categorias"}
               
              </p>
            </div>



                   <div
                    onClick={() => {
                      if (setShowSpecials) {
                       setShowSpecials()
                     }
              }}
              style={{
                width: 210,
                height: 70,
                backgroundColor: '#05FFDE',
                borderRadius: 9,
                marginHorizontal: 10,
                justifyContent: 'space-around',
                paddingHorizontal: 20,
                alignItems: 'center',
                flexDirection: 'row',
                display: "flex",
                shadowColor: '#000',
                shadowOffset: {
                  width: 3,
                  height: 5,
                },
                shadowOpacity: 0.14,
                shadowRadius: 0,
                elevation: 10,
              }}>
              <img
                src={require('./assets/promo.png')}
                style={{width: 30, height: 30, marginRight: 10}}
              />
              <p
                style={{
                  color: '#E81562',
                
                  fontSize: 22,
                  fontFamily: 'Roadstore',
                  textTransform: 'uppercase',
                  textShadowColor: '#7ED0E0',
                  textShadowOffset: {width: 2, height: 1},
                  textShadowRadius: 1,
                      }}>
                       {langEng ? "Specials": "Especiales"}
                
              </p>
            </div>

           
            </div>
            <div
              style={{
                zIndex: 100,
                flexDirection: 'row',
                justifyContent: 'space-around',
                paddingHorizontal: 20,
                  alignItems: 'center',
              
              }}>
                  <div
                  
                style={{flexDirection: 'row', alignItems: 'center', marginTop: 10,}}>
                <p
                  style={{
                      color: '#B8A8A8',
                      fontWeight: '300',
                      textAlign: 'center',
                      fontSize: 11,
                    }}>
                 (1)Please inform the waiter if you have any type of allergic condition (2) Price subject to change without notice (3) 15% gratuity will be added to tables of 4 or more people.
                    </p>
                     <p
                  style={{
                      color: '#000',
                      fontWeight: '900',
                      textAlign: 'center',
                      fontSize: 14,
                    }}>
                 Powered by boostyourmenu.com
                </p>
              </div>
            </div>
          </div>
          }
            

            

            
            {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              divBox={`0 0 256 256`}
            />
            </div>}
           
          </div>
        </div>

          {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}

        {showListProduct2 && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct2}
            />}
      </div>
     
    );
  };

export default Index;